module.exports = __webpack_public_path__ + "assets/empty-state.704a88cd.svg";